import type { StoreYard } from "../types";

export const initialStoreYards: StoreYard[] = [];
